import { useEffect, useRef, useState } from "react";
import { Play, X } from "lucide-react";

const SECONDS = 10;

export const UpNextOverlay = ({ next, onPlay, onCancel }) => {
  const [left, setLeft] = useState(SECONDS);
  const playRef = useRef(null);

  useEffect(() => {
    playRef.current?.focus();
    const t = setInterval(() => setLeft((s) => s - 1), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const onKey = (e) => {
      if (["Escape", "Backspace", "GoBack", "BrowserBack"].includes(e.key) || [461, 10009].includes(e.keyCode)) {
        e.preventDefault();
        onCancel();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onCancel]);

  useEffect(() => {
    if (left <= 0) onPlay();
  }, [left, onPlay]);

  return (
    <div data-testid="up-next-overlay" role="dialog" aria-label="Up next" className="absolute inset-0 z-20 bg-black/85 backdrop-blur-sm flex items-center justify-center p-6">
      <div className="flex flex-col sm:flex-row items-center gap-6 max-w-3xl w-full">
        <img
          src={next.thumbnail || `https://i.ytimg.com/vi/${next.youtube_id}/hqdefault.jpg`}
          alt={next.title}
          className="w-64 aspect-video object-cover rounded-sm border border-white/15"
        />
        <div className="flex-1 min-w-0">
          <p className="text-xs tracking-[0.2em] uppercase text-[#FF2A2A] mb-2" data-testid="up-next-countdown">
            Up next in {Math.max(left, 0)}s
          </p>
          <h3 className="font-display text-xl sm:text-2xl uppercase tracking-tight line-clamp-2" data-testid="up-next-title">
            {next.title}
          </h3>
          <div className="mt-5 flex gap-3">
            <button
              ref={playRef}
              data-testid="up-next-play-now"
              onClick={onPlay}
              className="inline-flex items-center gap-2 bg-white text-black px-6 py-3 rounded-sm font-semibold hover:bg-zinc-200 transition-colors"
            >
              <Play className="w-5 h-5 fill-black" /> Play Now
            </button>
            <button
              data-testid="up-next-cancel"
              onClick={onCancel}
              className="inline-flex items-center gap-2 bg-white/10 border border-white/25 px-6 py-3 rounded-sm font-semibold hover:bg-white/20 transition-colors"
            >
              <X className="w-5 h-5" /> Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
